import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Car } from "lucide-react";

export const Route = createFileRoute("/admin/vehicles")({
  component: () => (
    <StubAdminPage
      icon={Car}
      title="Vehicles"
      subtitle="Vehicle catalog and availability"
    />
  ),
});
